import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines } from "./motion-primitives";
import { useLang, richParts } from "@/i18n/LanguageContext";

const BAND_IMG = "/images/osrelis-10.jpg";

export const VisualBand = () => {
  const { c } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.15, 1.3]);

  return (
    <section ref={ref} data-testid="visual-band" className="relative flex h-[80vh] min-h-[520px] items-center overflow-hidden bg-[#061114]">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={BAND_IMG} alt="Aerial view of connected offshore platforms and supply vessel" className="h-full w-full object-cover" style={{ filter: "saturate(0.75) contrast(1.05)" }} />
      </motion.div>
      <div className="absolute inset-0" style={{ background: "linear-gradient(0deg, rgba(4,12,14,.7), rgba(4,12,14,.25) 45%, rgba(4,12,14,.6))" }} />
      <div className="relative z-[1] w-full px-6 md:px-[8vw]">
        <MaskedLines
          className="font-serif text-[clamp(34px,5vw,86px)] font-normal leading-[1.02] tracking-[-0.02em] text-paper"
          lines={c.visualBand.lines.map((l) => richParts(l))}
        />
      </div>
    </section>
  );
};
